import React from "react";
import "./loadingOverlay.css";

const LoadingOverlay = () => {
  return (
    <div
      className="loadingOverlayWrap"
    >
      <div className="loading-4">
        <span className="span1"></span>
        <span className="span2"></span>
        <span className="span3"></span>
      </div>
    </div>
  );
};

export default LoadingOverlay;
